<template>
    <div class="join-season w-100 h-100 d-flex justify-content-center align-items-center p-3">
        <div class="join-season-card text-center">
            <div v-if="loading">
                <span class="spinner-border spinner-border-sm me-2"></span>Comprobando código...
            </div>

            <div v-else-if="error">
                <i class="bi bi-x-circle-fill join-season-error-icon"></i>
                <div class="join-season-headline mt-3">Código no válido</div>
                <div class="join-season-detail">{{ error }}</div>
                <button type="button" class="btn btn-primary mt-4" @click="$router.push({name: 'Home'})">Volver</button>
            </div>

            <div v-else-if="joining">
                <span class="spinner-border spinner-border-sm me-2"></span>Uniéndote a {{ season.name }}...
            </div>

            <div v-else>
                <div class="join-season-label">Te han invitado a</div>
                <h1 class="join-season-title">{{ season.name }}</h1>
                <div class="join-season-detail mt-2">Inicia sesión o crea una cuenta para unirte.</div>

                <button type="button" class="btn btn-primary w-100 mt-4" @click="go_to_login">Iniciar sesión</button>
                <button type="button" class="btn btn-outline-secondary w-100 mt-2" @click="go_to_register">Crear cuenta</button>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'

// ONLINE mode's per-season landing page for a scanned/typed season code
// (see JoinCodeQR.vue's `path` prop and server.js's
// online_lookup_season_by_code/online_join_season) - the counterpart to
// EVENT mode's Auth.vue "/join/<code>" gate, but for picking a specific
// season instead of registering into the one live event.
export default {
    name: 'JoinSeason',
    data(){
        return {
            code: this.$route.params.code,
            season: null,
            loading: true,
            joining: false,
            error: null,
        };
    },
    async mounted(){
        try{
            const result = await api.season_by_join_code(this.code);
            this.season = result.season;
        }catch(ex){
            this.error = ex.message || 'No se ha podido comprobar el código.';
            this.loading = false;
            return;
        }

        // Await the same boot-time session-resume promise the router guard
        // uses (main.js) - without this, a hard refresh landing directly on
        // this URL could still see online_user as null while that restore
        // is in flight, and wrongly show the Login/Register choice to an
        // already-logged-in player.
        if(window.ensure_online_identity_checked)
            await window.ensure_online_identity_checked;

        if(this.$store.state.online_user){
            await this.join_and_go();
            return;
        }

        this.loading = false;
    },
    methods: {
        async join_and_go(){
            this.loading = false;
            this.joining = true;
            try{
                const result = await api.join_season(this.code);
                this.$store.commit('setPendingJoinSeasonCode', null);
                window.toast.success('¡Te has unido a ' + result.season.name + '!');
                this.$router.push({name: 'MyStages', params: {season_id: result.season.id}});
            }catch(ex){
                window.toast.error(ex.message || 'No se ha podido completar la inscripción.');
                this.$router.push({name: 'MySeasons'});
            }finally{
                this.joining = false;
            }
        },
        go_to_login(){
            this.$store.commit('setPendingJoinSeasonCode', this.code);
            this.$router.push({name: 'Login'});
        },
        go_to_register(){
            this.$store.commit('setPendingJoinSeasonCode', this.code);
            this.$router.push({name: 'Register'});
        }
    }
}
</script>

<style scoped>
    .join-season-card{
        width: 100%;
        max-width: 380px;
    }

    .join-season-label{
        font-family: "Archivo", sans-serif;
        font-weight: 700;
        font-size: 0.8rem;
        text-transform: uppercase;
        letter-spacing: 0.08em;
        color: var(--vc-text-600);
    }

    .join-season-title{
        font-family: "Archivo", sans-serif;
        font-size: 1.6rem;
        margin-top: 4px;
    }

    .join-season-headline{
        font-family: "Archivo", sans-serif;
        font-weight: 800;
        font-size: 1.4rem;
    }

    .join-season-detail{
        color: var(--vc-text-600);
        font-size: 0.9rem;
    }

    .join-season-error-icon{
        font-size: 3rem;
        color: var(--vc-danger-500);
    }
</style>
